import { useQuery } from '@tanstack/react-query'
import { authService } from '../services/authService'

/** Nombre, versión y vías de login del ambiente. No cambia mientras la app está abierta. */
export function useInfo() {
  return useQuery({ queryKey: ['info'], queryFn: authService.info, staleTime: Infinity })
}
